import React from 'react';
import { workOrderCustomFieldTypes } from '../../../../../../utils/constans';
import RowActions from '../../../../../dashboard/RowActions';

const CustomFieldRow = ({
  customField,
  removeField,
  editField,
}) => (
  <tr>
    <td data-th="Name">{customField.name}</td>
    <td data-th="Value">{customField.value}</td>
    <td data-th="Type">{workOrderCustomFieldTypes[customField.type]}</td>
    <td data-th="Action">
      <RowActions
        onEdit={(e) => {
          e.preventDefault();
          editField();
        }}
        onDelete={(e) => {
          e.preventDefault();
          removeField();
        }}
      />
    </td>
  </tr>
);

export default CustomFieldRow;
